// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;I lie down and sleep and rise again,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;because the Lord sustains me.<br> </p> </div></div>";
// Exports
module.exports = code;